module.exports = __webpack_public_path__ + "static/media/clothes-icon.afcc0766.svg";